import React, { useState } from "react";

import "./ShowAllProjectsPage.css";
import ListComponent from "../../modules/ListComponent/ListComponent";

function ShowAllProjectsPage(props) {
  const [amStudiotechnik, setAMStudiotechnik] = useState(
    props.match.params.studiotechnik
  );
  const [headline, setHeadline] = useState(createName(amStudiotechnik));
  const { onlyShowPublicProjects } = props;

  function createName(selectedStudiotechnik) {
    let headline = "Alle ";
    const selected = `${selectedStudiotechnik}`;
    if (selected.localeCompare("select_projekt_alle_filme") === 0) {
      headline += "Filme";
    } else if (selected.localeCompare("select_projekt_vfx") === 0) {
      headline += "VfX-Projekte";
    } else if (selected.localeCompare("select_projekt_im") === 0) {
      headline = "Irgendwas mit Medien";
    } else if (selected.localeCompare("select_projekt_game") === 0) {
      headline += "Games";
    } else if (selected.localeCompare("select_projekt_ca") === 0) {
      headline += "Animationsfilme";
    } else if (selected.localeCompare("select_projekt_tv") === 0) {
      headline += "Fernsehsendungen";
    } else if (selected.localeCompare("select_projekt_ton") === 0) {
      headline += "Tonprojekte";
    }
    return headline;
  }

  return (
    <div className="allesAnzeigen-container">
      <h1 className="headline">{headline}</h1>
      <ListComponent
        contentType={`${amStudiotechnik}?nur_oeffentlich=${
          onlyShowPublicProjects ? 1 : 0
        }`}
        displayListButtons
        key={onlyShowPublicProjects}
      />
    </div>
  );
}

export default ShowAllProjectsPage;
